import { CloudArrowDownIcon, Typography, emptyFragment } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { findLink } from '../../../../../LinkyLinky';
import { Resource } from '../../../../../Resource/Types';
import { T } from '../../../../../Translations';
import ExternalLink from '../../../ExternalLink';

interface Props<T> {
  experienceResource: Resource<T>;
}

function DownloadOverview<T>({ experienceResource }: Props<T>) {
  return findLink('download-overview-pdf', experienceResource.links)
    .map((pdfLink) => (
      <div className="flex items-center gap-x-2.5">
        <CloudArrowDownIcon color="black" size="md" />
        <ExternalLink href={pdfLink.href} data-intercom-target="experience-download-overview-pdf">
          <Typography color="teal" variant="bodyMedium">
            <T kind="Download Program Overview" />
          </Typography>
        </ExternalLink>
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(DownloadOverview);
